import { TGetColorStateDefinition } from '../types';

/**
 * Básicamente agrega la definición de borderLeftColor, borderRightColor, etc.
 */
function buildColorsObject(definition: Partial<TGetColorStateDefinition>) {
  return {
    ...definition,
    ...(definition.borderColor
      ? {
          borderLeftColor: definition.borderColor,
          borderRightColor: definition.borderColor,
          borderBottomColor: definition.borderColor,
          borderTopColor: definition.borderColor,
        }
      : undefined),
  } as TGetColorStateDefinition;
}

export default buildColorsObject;
